import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle, Shield, Award } from "lucide-react";

export default function HairTransplant() {
  const { t } = useTranslation();

  return (
    <div className="pt-20">
      <Helmet>
        <title>Hair Transplant in Turkey | FUE & DHI Clinics | Monimek</title>
        <meta name="description" content="Save up to 75% on Hair Transplants in Turkey. JCI-accredited clinics in Istanbul offering FUE and DHI methods. Free consultation with board-certified surgeons." />
        <link rel="canonical" href="https://www.monizmek.com/treatments/hair-transplant" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalProcedure",
              "name": "Hair Transplant",
              "description": "FUE and DHI Hair Transplantation performed by board-certified surgeons in JCI-accredited hospitals in Turkey.",
              "bodyLocation": "Head",
              "procedureType": "Surgical",
              "provider": {
                "@type": "MedicalBusiness",
                "name": "Monimek Partner Clinics",
                "address": {
                  "@type": "PostalAddress",
                  "addressCountry": "Turkey",
                  "addressLocality": "Istanbul"
                }
              },
              "offers": {
                "@type": "AggregateOffer",
                "priceCurrency": "USD",
                "lowPrice": "2000",
                "highPrice": "3500",
                "offerCount": "2"
              }
            }
          `}
        </script>
      </Helmet>

      <section className="bg-[#F8FAFC] py-20">
        <div className="max-w-[1200px] mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl sm:text-5xl font-black text-[#0B3C5D] font-outfit mb-6">Hair Transplant in Turkey</h1>
            <p className="text-lg text-[#6B7280] mb-8">
              Turkey is the global capital for hair transplantation. At Monimek, we partner with the finest JCI-accredited clinics and board-certified surgeons in Istanbul to offer permanent, natural-looking results using advanced FUE and DHI graft extraction techniques.
            </p>
            <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 bg-[#3FA7D6] text-white font-bold rounded-full hover:bg-[#0B3C5D] transition-colors">
              Get Your Free Quote <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
          <div>
            <img src="https://images.pexels.com/photos/8995900/pexels-photo-8995900.jpeg?auto=compress&cs=tinysrgb&w=800" alt="Hair Transplant Turkey FUE Surgery" className="rounded-3xl shadow-xl w-full h-[400px] object-cover" />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1000px] mx-auto px-6">
          <h2 className="text-3xl font-bold text-[#0B3C5D] font-outfit mb-8 text-center">Why Choose Turkey for Hair Transplants?</h2>
          <div className="grid sm:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <Award className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">World-Class Surgeons</h3>
              <p className="text-[#6B7280] text-sm">Our partner clinics feature ISHRS-certified doctors with years of experience in successful hair graft extraction.</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <Shield className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">JCI-Accredited Safety</h3>
              <p className="text-[#6B7280] text-sm">We rigidly vet our partners, working only with internationally accredited health facilities to ensure perfect safety.</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
              <CheckCircle className="w-10 h-10 text-[#3FA7D6] mb-4" />
              <h3 className="font-bold text-lg mb-2">Complete VIP Packages</h3>
              <p className="text-[#6B7280] text-sm">Save up to 75% compared to the US. Our packages include premium hotel stays, airport transfers, and post-op care.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
